import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import clsx from "clsx";
import { Switch, Route, Redirect } from "react-router-dom";
import { Drawer, Divider, IconButton } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { withStyles } from "@material-ui/core/styles";
import { Workspace, SidebarWrapper, Header } from "components";
import NftDepTxFilter from "components/Filter/NftDepTxFilter";
import InGameItemTxFilter from "components/Filter/InGameItemTxFilter";
import UsersByAdFilter from "components/Filter/UsersByAdFilter";
import NftDepLowTxFilter from "components/Filter/NftDepLowTxFilter";
import DashboardStyles from "containers/DashboardStyles";
import RoutesDashboard from "routes/RoutesDashboard";
import RoutesDenchu from "routes/RoutesDenchu";
import RoutesNtt from "routes/RoutesNtt";
import RoutesNttFt from "routes/RoutesNttFt";
import RoutesGGG from "routes/RoutesGGG";
import RoutesHokuden from "routes/RoutesHokuden";
import RoutesPicTreeMap from "routes/RoutesPicTreeMap";
import { setFilterDrawerState } from "actions";
import {
  AdminUsers,
} from "pages";

function resizeDispatch() {
  if (typeof Event === "function") {
    window.dispatchEvent(new Event("resize"));
  } else {
    const evt = window.document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
  }
}
class DashboardContainer extends Component {
  state = {
    opened: true,
    username: "",
  };

  handleDrawerToggle = (type) => {
    this.setState({ opened: type === "submenu" ? true : !this.state.opened });
    resizeDispatch();
  };

  handleFullscreenToggle = () => {
    const element = document.querySelector("#root");
    const isFullscreen =
      document.webkitIsFullScreen || document.mozFullScreen || false;
    element.requestFullScreen =
      element.requestFullScreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      function () {
        return false;
      };
    document.cancelFullScreen =
      document.cancelFullScreen ||
      document.webkitCancelFullScreen ||
      document.mozCancelFullScreen ||
      function () {
        return false;
      };
    isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
  };

  componentDidMount() {
    if (window.location.pathname == "/home") {
      const accessKeyValue = localStorage.getItem("access_key");
      if (accessKeyValue !== undefined) {
        switch (accessKeyValue) {
          case "WPZssCHh3jDp8bwIKhrwA7Rk89PN":
            this.props.history.push(
              "/game/luckyfarmer/marketplace-sale/overview"
            );
            break;
          case "qjoDw9xh16E5giTPmhhByywmaLfN":
            this.props.history.push(
              "/game/lostarchiveplus/marketplace-sale/overview"
            );
            break;
          case "r6pjc6qlvnw4znji7nzkwjx2wag8":
            this.props.history.push("/game/dragonramen/overview");
            break;
          case "EqOsAVMYK4pqtSnVDgz67zVKUXFy":
            this.props.history.push(
              "/game/graffitiracer/marketplace-sale/overview"
            );
            break;
          case "cRaANwUa68M3s0N0oF4U6kiADDli":
            this.props.history.push(
              "/game/roguerollrulers/marketplace-sale/overview"
            );
            break;
          case "lUF2uNRqBJO7EUv9zNnA3wloxxPF":
            this.props.history.push(
              "/game/bouncybunny/marketplace-sale/overview"
            );
            break;
          case "MHoNNpheuCs67M80p6IB7MFCe9i8":
            this.props.history.push("/game/pictree/tepco/home");
            window.location.reload(true);
            break;
          case "BDvE9Hd11ZKaHjuPWfnzIGQrvq1d":
            this.props.history.push("/game/pictree/ntt/photos/overview");
            window.location.reload(true);
            break;
          case "z7n3q9m1x4p2v0ydk8twr5fb":
            this.props.history.push("/game/pictree/ntt-ft/photos/overview");
            window.location.reload(true);
            break;
          case "86u0tva5zzajky0i4wpynx0tekro":
            this.props.history.push("/game/pictree/all/home");
            window.location.reload(true);
            break;
          case "N9SuvYfjxFcxiVumz4zo4O1sws4h":
            this.props.history.push("/game/pictree/ntt/photos/map");
            window.location.reload(true);
            break;
          case "lqdp4c7fuwgfz89og7q4x9f3":
            this.props.history.push("/game/pictree/hokuden/photos/overview");
            window.location.reload(true);
            break;
          default:
        }
      }
    }
  }

  componentWillUnmount() {
    // this.unlisten();
  }

  deepCloneRoutes = (items = []) =>
    items.map(it => ({
      ...it,
      children: it.children ? this.deepCloneRoutes(it.children) : undefined,
    }));

  getBaseMenuByAccessKey = (accessKeyValue) => {
    // Tepco: MHoNNpheuCs67M80p6IB7MFCe9i8, NTT-ME: BDvE9Hd11ZKaHjuPWfnzIGQrvq1d
    // GGG: 86u0tva5zzajky0i4wpynx0tekro, PicTreeMap: N9SuvYfjxFcxiVumz4zo4O1sws4h, NTT-FT: z7n3q9m1x4p2v0ydk8twr5fb
    if (process.env.REACT_APP_SUPERUSER !== accessKeyValue) {
      if (accessKeyValue === "MHoNNpheuCs67M80p6IB7MFCe9i8") {
        return this.deepCloneRoutes(RoutesDenchu.items);
      } else if (accessKeyValue === "BDvE9Hd11ZKaHjuPWfnzIGQrvq1d") {
        return this.deepCloneRoutes(RoutesNtt.items);
      } else if (accessKeyValue === "z7n3q9m1x4p2v0ydk8twr5fb") {
        return this.deepCloneRoutes(RoutesNttFt.items);
      } else if (accessKeyValue === "86u0tva5zzajky0i4wpynx0tekro") {
        return this.deepCloneRoutes(RoutesGGG.items);
      } else if (accessKeyValue === "lqdp4c7fuwgfz89og7q4x9f3") {
        return this.deepCloneRoutes(RoutesHokuden.items);
      } else if (accessKeyValue === "N9SuvYfjxFcxiVumz4zo4O1sws4h") {
        return this.deepCloneRoutes(RoutesPicTreeMap.items);
      } else {
        // vendor 一致だけ抽出（これも複製）
        const filtered = RoutesDashboard.items.filter(
          x => x.vendor === accessKeyValue
        );
        return this.deepCloneRoutes(filtered);
      }
    }
    return this.deepCloneRoutes(RoutesDashboard.items);
  };

  getRouteItems() {
    const accessKeyValue =
      localStorage.getItem("access_key") !== null
        ? localStorage.getItem("access_key")
        : this.props.accessKey;

    const menu = this.getBaseMenuByAccessKey(accessKeyValue);

    // DEA admin 用メニュー
    if (localStorage.getItem("dea_role") === "admin") {
      const adminItem = {
        path: "/manage/users",
        name: "ユーザー管理",
        type: "link",
        icon: "audience",
        component: AdminUsers,
        sideBar: true,
        category: "ADMIN",
      };
      const exists = menu.some(it => it.path === adminItem.path);
      if (!exists) menu.push(adminItem);
    }
    return menu;
  }

  render() {
    const { classes, currentPage, filterDrawerState, setFilterDrawerState } =
      this.props;
    const { opened } = this.state;
    const routesItems = this.getRouteItems();

    const handleDrawerClose = () => {
      setFilterDrawerState(!filterDrawerState ? currentPage : false);
    };

    const getRoutes = (
      <Switch>
        {/* <Route exact path='/profile' component={Profile} name='Profile' /> */}
        <Route exact path="/game/pictree/home">
          <Redirect to="/game/pictree/tepco/home" />
        </Route>
        <Route exact path="/game/pictree/checkin">
          <Redirect to="/game/pictree/tepco/checkin" />
        </Route>
        <Route exact path="/game/pictree/photos/overview">
          <Redirect to="/game/pictree/tepco/photos/overview" />
        </Route>
        <Route exact path="/game/pictree/photos/map">
          <Redirect to="/game/pictree/tepco/photos/map" />
        </Route>
        <Route exact path="/game/pictree/plot">
          <Redirect to="/game/pictree/plot/overview" />
        </Route>
        <Route exact path="/game/pictree/mission/overview">
          <Redirect to="/game/pictree/tepco/mission/overview" />
        </Route>
        <Route exact path="/game/pictree/mission/ranking">
          <Redirect to="/game/pictree/tepco/mission/ranking" />
        </Route>
        <Route exact path="/game/pictree/report/plant">
          <Redirect to="/game/pictree/tepco/report/plant" />
        </Route>
        {routesItems.map((item, index) =>
          item.type === "external" ? (
            <Route
              exact
              path={item.path}
              component={item.component}
              name={item.name}
              key={index}
            />
          ) : item.type === "submenu" ? (
            item.children.map((subItem) =>
                subItem.type === "submenu" ? (
                subItem.children.map((subsubItem) => (
                  <Route
                    exact
                    path={subsubItem.absolutePath ? subsubItem.absolutePath : `${item.path}${subItem.path}${subsubItem.path}`}
                    component={subsubItem.component}
                    name={subsubItem.name}
                  />
                ))
              ) : subItem.disabled ? null : (
                <Route
                  exact
                  path={`${item.path}${subItem.path}`}
                  component={subItem.component}
                  name={subItem.name}
                />
              )
            )
          ) : (
            <Route
              exact
              path={item.path}
              component={item.component}
              name={item.name}
              key={index}
            />
          )
        )}
      </Switch>
    );

    return (
      <Fragment>
        <Header
          logoAltText="Digital Entertainment Asset Admin"
          logo={`/static/images/logo35h.png`}
          toggleDrawer={this.handleDrawerToggle}
          isAuthenticated={this.props.isAuthenticated}
          handleLogout={this.props.handleLogout}
          currentLocation={this.props.location.pathname}
        />
        <div className={classNames(classes.panel, "theme-dark")}>
          <SidebarWrapper
            routes={routesItems}
            opened={opened}
            toggleDrawer={this.handleDrawerToggle}
            toggleFullscreen={this.handleFullscreenToggle}
            handleLogout={this.props.handleLogout}
          />
          <div
            className={clsx(classes.content, {
              [classes.contentShift]: filterDrawerState,
            })}
          >
            <Workspace
              opened={opened}
              currentLocation={this.props.location.pathname}
            >
              {getRoutes}
            </Workspace>
          </div>
          <div id="page-data"></div>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="right"
            open={filterDrawerState ? true : false}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={handleDrawerClose}>
                <ChevronRightIcon />
              </IconButton>
            </div>
            <Divider />
            <div className={classes.drawerContent}>
              {currentPage === "/nftdep/user-ban" && <NftDepLowTxFilter />}
              {currentPage === "/nftdep/nft-transaction-history" && (
                <NftDepTxFilter property="nft" />
              )}
              {currentPage === "/users/list-by-adcode" && <UsersByAdFilter />}
              {currentPage.indexOf("ingame-sale/transaction-history") !== -1 ? (
                <InGameItemTxFilter property="item" />
              ) : null}
            </div>
          </Drawer>
        </div>
      </Fragment>
    );
  }
}

DashboardContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  accessKey: state.page.accessKey,
  filterDrawerState: state.page.filterDrawerState,
  currentPage: state.page.currentPage,
});

const mapDispatchToProps = (dispatch) => ({
  setFilterDrawerState: (param) => dispatch(setFilterDrawerState(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(DashboardStyles, { withTheme: true })(DashboardContainer));
